// extracted by mini-css-extract-plugin
module.exports = {"flexbox":"DocumentViewer_flexbox__2d7Sk","downloadBtn":"DocumentViewer_downloadBtn__2qzg_","downloadBtnBMW":"DocumentViewer_downloadBtnBMW__2RWqB"};